cpText = {};

function check_focus(was, bezeichnung){
    if(was.value == bezeichnung){
        was.value = "";
    }
}

function check_blur(was, bezeichnung){
    if(was.value == "" || was.value == " " || was.value == "  " || was.value == "   "){
        was.value = bezeichnung;
    }
}

function displayLoader(){
    $(".js-loader").show();
}
function hideLoader(){
    $(".js-loader").hide();
}

$(document).ready(function() {
    $('.js-img_zoom').magnificPopup({
        type:'image'
    });

    $(".js-msg_box_close").on("click", function(){
        hideMsgBox();
    });

    $(".js-msg_box_close_ok").on("click", function(){
        if($(this).data("url") != ""){
            document.location = $(this).data("url");
        }else{
            hideMsgBox();
        }
    });

    $("input").on("keyup", function(){
        hideMsgBox();
    });
});

function displayErrorBox(error){
    $(".js-msg_box_close_ok").data("url", "");
    $(".js-msg_box").addClass("msg_box-error").removeClass("msg_box-confirm");
    $(".js-msg_box_close").hide();
    if($(".js-msg_box").is(":visible")){
        $(".js-msg_box").hide();
    }
    $.when($(".js-msg_box_text").text(error)).done(function(){
        $(".js-msg_box").fadeIn()
    });
}

function displayConfirmBox(error, url){
    $(".js-msg_box_close_ok").data("url", url);
    $(".js-msg_box").addClass("msg_box-confirm").removeClass("msg_box-error");
    $(".js-msg_box_close").show();

    if($(".js-msg_box").is(":visible")){
        $(".js-msg_box").hide();
    }
    $.when($(".js-msg_box_text").text(error)).done(function(){
        $(".js-msg_box").fadeIn()
    });
}

function hideMsgBox(){
    if($(".js-msg_box").is(":visible")){
        $.when($(".js-msg_box").fadeOut()).done(function(){
            $(".js-msg_box_text").text("");
        });
    }
}

function initHeaderSlider(){
    var swiper = new Swiper('.swiper-container', {
        slidesPerView:1,
        spaceBetween:0,
        loop:true,
        effect:'fade',
        autoplay:{
            delay:5000,
            disableOnInteraction:false,
        },
    });
}

function confirmCookie(ajaxUrl, actualLink){
    if (actualLink == "") return false;

    $.ajax({
        url: ajaxUrl,
        method: "post",
        data: {actualLink:actualLink},
        success: function(data){
            if (data == 1){
                $(".cookie_con").css("display","none");
            } else {
                return false;
            }
        }
    })
}